<div id="SupplementalAnchor"></div>
<div [@questionTrig]=currentState  (@questionTrig.start)="openSupplementEnd($event)" cdkDropListGroup>
    <question-title [question]="question" ></question-title>

    <!-- Verse Label -->
    <div *ngIf="question.verses" >
      <div 
        class="captionText bold flex  "  
        *ngFor="let v of question.verses; let first = first;" 
      >
        <span 
          class="verseContainer verseTitle buttonHighlight space " 
          (click)="selectVerse(v.ref, v.body)">{{v.ref}}&nbsp;
        </span>
        &nbsp;

        <div *ngIf="first" class="regularText greyText elabel">
          <div class="r180"><h1>&#10162;</h1></div
            ><h3>&nbsp;&nbsp;{{config?.questionTemplateExplore}}</h3>
        </div>
        <div *ngIf="first" class="flexEnd">
          <div *ngIf="!profile?.anonymous && !!profile?.uid" class="askButton button" (click)="openStudentQuestion()">{{config?.questionTemplateGotQuestion}}</div>
            <div class="regularText greyText emobile" >
              <div class="r180">
                <h3>&#10162;</h3>
              </div>
              <h6>&nbsp;&nbsp;{{config?.questionTemplateExplore}}</h6>
            </div>
           <h3 *ngIf="!profile?.anonymous && !!profile?.uid" class="askButtonMobile button" (click)="openStudentQuestion()">{{config?.questionTemplateGotQuestion}}</h3>
        </div>
      </div>
    </div>

    <div *ngIf="!question.verses">
        <div class="noVerseButtons" *ngIf="!!profile">
            <div   *ngIf="questionID !== '19' && lessonID !== '8'"  class="askButton button" (click)="openStudentQuestion()">{{config?.questionTemplateGotQuestion}}</div>
            <h3   *ngIf="questionID !== '19' && lessonID !== '8'"  class="askButtonMobile button" (click)="openStudentQuestion()">{{config?.questionTemplateGotQuestion}}</h3>
            <div *ngIf="questionID === '19' && lessonID === '8'" class="askButton button pulse" (click)="openStudentQuestion()">{{config?.questionTemplateChurch}}</div>
            <h3  *ngIf="questionID === '19' && lessonID === '8'" class="askButtonMobile button pulse" (click)="openStudentQuestion()">{{config?.questionTemplateChurch}}</h3>
          
        </div>
    </div>



    <!-- All Correct SVG -->
    <div [ngClass]="{'correctFlex': allCorrect, 'incorrectFlex': !allCorrect}">
        <div 
          *ngIf="allCorrect"
          style="width: 10%; margin: 10px auto 10px auto">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
    </div>

    <!-- Instructions Section -->
    <p *ngIf="question.questionType === 'wordCloud'" class="instructions greyText regularText instruction_container ">
      {{config?.questionTemplateWordCloudInstructions}}
    </p>

    <p *ngIf="question.questionType === 'checkbox'" class="instructions greyText regularText instruction_container">
       {{config?.questionTemplateCheckboxInstructions}}
      </p>
      
    <p *ngIf="question.questionType === 'radio'" class="instructions greyText regularText instruction_container">
      {{config?.questionTemplateRadioInstructions}}
    </p>


    <!-- Verse Prompts -->
    <div 
      *ngIf="question.questionType != 'trueOrFalse' && question.questionType !== 'truthConfirmation' && question.questionType !== 'text'" 
      class="content_container"
    >
      <div class="spanwrapper" *ngIf="vpShown">
        <span  *ngFor="let vp of versePrompts" > 
          <span class="captionText">
            
            {{vp.textBefore}}
            <div 
              [attr.id]="versePromptIDs[vp.$key]" 
              class="blank regularText regularBorder" 
              (click)="selectBlank(vp)" 
              cdkDropList
              (cdkDropListDropped)="onDrop($event, versePromptIDs[vp.$key])"
              [cdkDropListData]="answersArray"
              >
              <div 
                *ngIf="answers[vp.$key] && question.questionType !== 'radio'"
                class=removeChoice (click)="selectAnswer(answers[vp.$key], $event, true)">&times;
              </div>
              <div 
                *ngIf="answers[vp.$key] && answers[vp.$key].choice && question.questionType !== 'radio'"  
                (click)="closeModal($event)" 
                class="choicePadding" >
                <div 
                  
                  class="choiceLabel captionText"  
                  [ngClass]="{correct:answers[vp.$key].correct, incorrect:!answers[vp.$key].correct}"
                  (click)="selectAnswer(answers[vp.$key], $event)"
                  >
                    {{answers[vp.$key]?.choice}}   
                </div>
              </div>
              <div 
                *ngIf="question.questionType === 'radio' && radioDisplayAnswer"
                [ngClass]="{correct:answers[vp.$key]?.correct, incorrect:!answers[vp.$key]?.correct}" 
                class="choicePadding" 
              >
                <label class="choiceLabel captionText " >{{radioDisplayAnswer}}</label>
              </div>
            </div>
            {{vp.textAfter}}
            </span>
            <span *ngIf="vp.newline"><br *ngFor="let n of vp.newline"></span>
          </span>
      </div>
    </div>

        <div *ngIf="question.questionType === 'radio'" class="radioButtonContainer flexy">
            <div *ngFor="let c of question.choices"  style="margin: 10px;">
              <label class="container">
                  <span class=" radioLabel captionText">{{c}}</span>
                    <input type="radio" name="radio" (click)="saveAnswerWithIndex(c)">
                    <span class="radiomark"></span>
                </label>
            </div>
          </div>

        <!-- True or False -->
        <div *ngIf="question.questionType === 'trueOrFalse'">
            <div class="radioButtonContainer">
                <!-- <h3 style="text-align: center"><span class="captionText extraBold">True or False? </span><span class="bold regularText reallyDarkGreyText">{{question.trueFalseQuestion}}</span></h3> -->
                <h3 style="text-align: center"><span class="bold regularText reallyDarkGreyText">{{question.trueFalseQuestion}}</span></h3>
                <form class="flexy" >
                    <label class="container">
                        <span class="trueFalseLabel captionText">{{config?.questionTemplateTrue}}</span>
                          <input type="radio" name="radio" (click)="saveTrueOrFalse('true')">
                          <span class="radiomark"></span>
                      </label>
                      &nbsp;&nbsp;&nbsp;
                      <label class="container">
                          <span class="trueFalseLabel captionText">{{config?.questionTempalteFalse}}</span>
                            <input type="radio" name="radio" (click)="saveTrueOrFalse('false')">
                            <span class="radiomark"></span>
                      </label>
                </form>
            </div>
          </div>

        <!-- text -->
        <div *ngIf="question.questionType === 'text'">
            <!-- <div class="content_container" [innerHtml]="body | newline"> -->
              <div class="content_container">
              <h2 *ngFor="let b of question.text" class="narrowText reallyDarkGreyText">{{b}}<br></h2>
            </div>
        </div>

        <!-- truthConfirmation -->
        <div *ngIf="question.questionType === 'truthConfirmation'">
          <div class="radioButtonContainer">
              <!-- <h3 style="text-align: center"><span class="captionText extraBold">True or False? </span><span class="bold regularText reallyDarkGreyText">{{question.trueFalseQuestion}}</span></h3> -->
              <form class="flexy" >



                  <label class="container">
                      <span class="radioLabel captionText">{{config?.questionTemplateYes}}</span>
                        <input type="radio" name="radio" (click)="truthConfirmed('true')">
                        <span class="radiomark"></span>
                    </label>
                    &nbsp;&nbsp;&nbsp;
                    <label class="container">
                        <span class="radioLabel captionText">{{config?.questionTemplateNo}}</span>
                          <input type="radio" name="radio" (click)="truthConfirmed('false')">
                          <span class="radiomark"></span>
                    </label>
                </form>
          </div>
        </div>
        <!-- Checkbox Answers -->
        <div *ngIf="question.questionType === 'checkbox'">

        </div>


        <!-- [dragula]="wordBag" -->
        <!-- [dragulaModel]='question.choices'  -->
        <!-- [dragulaOptions]="dragOptions" -->

        <!-- Word cloud -->
        <div 
          cdkDropList
          *ngIf="question.questionType === 'wordCloud'"
          style="touch-action: none;"
          class="choiceContainer" 
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="question.choices"
          (cdkDropListDropped)="onDrop($event, 'wordCloud')"
        >
              <div  *ngFor="let c of question.choices"  >
              <div 
               cdkDrag
                [cdkDragData]="c"
                *ngIf="shouldShowChoice(c)" 
                class="choiceLabel captionText unselected" 
                style="touch-action: none;" 
                (click)="selectChoice(c, $event)" >{{c}}</div>
            </div>
        </div>

          <div [attr.id]="bodyID" *ngIf="allCorrect && question.body" class="bodyContainer"><div class="body regularText fade" [innerHtml]="question.body | newline"></div></div>
          <!-- Supplement -->
          <!-- Supplement buttons -->
          
          <div *ngIf="supplements">
              <div class="supplementButtons" *ngFor="let supplement of supplements | async">
                <div class="supButton button3" (click)="openSupplement(supplement)">{{supplement?.title}}</div>
              </div>
           </div>
</div>         
 <div class="supContainer" [@supplementTrigger]=supplementState (@supplementTrigger.start)="closeSupplementEnd($event)">
  <!-- <div class="supContainer" [@supplementTrigger]=supplementState> -->
   <!-- <div *ngIf="supplementState === 'supplement'"> -->
    <div style="text-align:center">
      <div class="flexCol" >
        <h1 class="centerArrow button3" (click)="closeSupplement($event)" >&#8682;</h1>
        <h2  class="supButton button3" (click)="closeSupplement($event)"> {{config?.questionTemplateBack}}</h2>
      </div>
    </div>
    <h1 class="supplementTitle">{{selectedSupplement?.title}}</h1>
    <p class="supplementBody" [innerHtml]="selectedSupplement?.body | newline"></p>
  <!-- </div> -->
</div>

<!-- </div> -->
<div id="verseModal" class="modal" [ngClass]="{modalExit:!showVerse, hide: !showVerse}" (click)="closeModal($event)"> <!-- old id = "myMoal" -->
  <!-- The Verse Modal -->
        <!-- Modal content -->
        <div class="modalContent" (click)="stopPropagation($event)">
            <div class="modal-header">
                <span class="close" (click)="setVerseShown(false)">&times;</span>
                <h2>{{config?.questionTemplateVersion}}</h2>
            </div>
              <div class="modal-body">
              <h2 *ngIf="selectedVerse">{{selectedVerse.ref}}</h2>
              <p  *ngIf="selectedVerse">{{selectedVerse.body}}</p>
            </div>
            <div class="modal-footer">
            <h3></h3>
            </div>
        </div>
  </div>
  <!-- Contact Component -->

    <div *ngIf="userQuestion==='show' && !( questionID === '19' && lessonID === '8')" class="QuestionBackdrop" [@userQuestion]="userQuestion" >
      <form (ngSubmit)="submitStudentQuestion($event)"  class="QuestionBorder">
        <div class="btnctn"><span class="closebtn" (click)="closeStudentQuestion()">&times;</span></div> <br>
        <h1 class="regularText whiteText " style="display: block; text-align: center">{{config?.questionTemplateAsk}}</h1>
        <h6 class="regularText whiteText userQuestionFormatter" style="display: block; text-align: left">{{config?.questionTemplateQuestion}}</h6>
        <textarea
          class="message"
          name="moreinfo"
          cols="60"
          rows="10"
          placeholder="Please allow up to 3 days for a response." 
          required="required" 
          [(ngModel)]="questionMessage"
        >
        </textarea><br>
        <button class="buttonConfig button" >{{config?.questionTemplateSubmit}}</button>
        <h3 class="regularText whiteText" style="text-align: center;" >{{questionError}}</h3>
      </form>
  </div>

<!-- Come to church prompt -->
<div *ngIf="userQuestion==='show' && questionID === '19' && lessonID === '8'" class="QuestionBackdrop" [@userQuestion]="userQuestion" >
  <form (ngSubmit)="SendGoToChurchMessage($event)"  class="QuestionBorder">
    <div class="btnctn"><span class="closebtn" (click)="closeStudentQuestion()">&times;</span></div> <br>
    <h1 class="regularText whiteText " style="display: block; text-align: center">{{config?.questionTemplateFindChurch}}</h1>
    <h6 class="regularText whiteText userQuestionFormatter " style="display: block; text-align: left">{{config?.questionTemplateEmail}}</h6>
    <input id="questionTitleInput" class="short" type="email" name="email" placeholder="Your email" [(ngModel)]="questionUserEmail">
    <h6 class="regularText whiteText userQuestionFormatter" style="display: block; text-align: left">{{config?.questionTemplateQuestion}}</h6>
    <textarea class="message" name="moreinfo" cols="60" rows="10" required="required" [(ngModel)]="churchMessage">
      </textarea><br>
    <button class="buttonConfig button" >{{config?.questionTemplateSend}}</button>
    <h3 class="regularText whiteText" style="text-align: center;" >{{questionError}}</h3>
  </form>
</div>